/** Always a string. Never "[object Object]". */
export function getErrorMessage(error) {
  if (!error) return "";
  if (typeof error === "string") return error.trim();
  if (typeof error.message === "string" && error.message.trim() && error.message !== "[object Object]") {
    return error.message.trim();
  }
  return "";
}

/** Map of field name -> message. */
export function getFieldErrors(error) {
  if (!error || typeof error !== "object") return {};
  if (error.fieldErrors && typeof error.fieldErrors === "object") return error.fieldErrors;
  const fields = {};
  (error.errors || []).forEach((item) => {
    if (item && item.field && item.message && !fields[item.field]) fields[item.field] = String(item.message);
  });
  return fields;
}
